export function animatedScrollTo(targetY: number, duration: number): void {
  const targetX = window.pageXOffset;
  const initialY = window.pageYOffset;
  const baseY = (initialY + targetY) / 2;
  const difference = initialY - baseY;
  const startTime = performance.now();

  function step() {
    const normalizedTime = Math.min((performance.now() - startTime) / duration, 1);
    const y = baseY + difference * Math.cos(normalizedTime * Math.PI);
    window.scrollTo(targetX, y);
    if (normalizedTime < 1) {
      window.requestAnimationFrame(step);
    }
  }
  window.requestAnimationFrame(step);
}



// WEBPACK FOOTER //
// ./frontend/src/lib/animate.ts